// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SignatureChoice_choices__Otmip {
  display: flex;
  gap: 12px;
}
.SignatureChoice_choices__Otmip li {
  width: calc(50% - 6px);
  background-color: #FFF;
  list-style-type: none;
  border-radius: 8px;
  padding: 18px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  border: 1px solid #d8d8ff;
  font-size: 20px;
  font-weight: 400;
  color: #00007a;
  cursor: pointer;
}
.SignatureChoice_choices__Otmip li svg {
  width: auto;
  height: 32px;
}
.SignatureChoice_choices__Otmip li svg path {
  fill: #4343ff;
}
.SignatureChoice_choices__Otmip li:hover {
  border-color: #4343ff;
  color: #4343ff;
}
.SignatureChoice_choices__Otmip li.SignatureChoice_active__78fN2 {
  border: none;
  background-color: #4343ff;
  color: #FFF;
  cursor: initial;
}
.SignatureChoice_choices__Otmip li.SignatureChoice_active__78fN2 svg path {
  fill: #FFF;
}

.SignatureChoice_checkbox__wq6EA label {
  font-weight: 300;
}
.SignatureChoice_checkbox__wq6EA span {
  display: inline;
}
.SignatureChoice_checkbox__wq6EA a {
  text-decoration: underline;
}

@media screen and (max-width: 600px) {
  .SignatureChoice_choices__Otmip {
    flex-direction: column;
  }
  .SignatureChoice_choices__Otmip li {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/RCPro/pages/SignatureChoice/SignatureChoice.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,SAAA;AAIJ;AAFI;EACI,sBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,cCdG;EDeH,eAAA;AAIR;AAFQ;EACI,WAAA;EACA,YAAA;AAIZ;AAFY;EACI,aC1BL;AD8BX;AAAQ;EACI,qBC/BD;EDgCC,cChCD;ADkCX;AACQ;EACI,YAAA;EACA,yBCrCD;EDsCC,WAAA;EACA,eAAA;AACZ;AACY;EACI,UAAA;AAChB;;AAMI;EACI,gBAAA;AAHR;AAKI;EACI,eAAA;AAHR;AAKI;EACI,0BAAA;AAHR;;AAQA;EACI;IACI,sBAAA;EALN;EAMM;IACI,WAAA;EAJV;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.choices{\n    display: flex;\n    gap: 12px;\n\n    li{\n        width: calc(50% - 6px);\n        background-color: #FFF;\n        list-style-type: none;\n        border-radius: 8px;\n        padding: 18px 12px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n        gap: 10px;\n        border: 1px solid colors.$primary2;\n        font-size: 20px;\n        font-weight: 400;\n        color: colors.$primary8;\n        cursor: pointer;\n\n        svg{\n            width: auto;\n            height: 32px;\n\n            path{\n                fill: colors.$primary4;\n            }\n        }\n\n        &:hover{\n            border-color: colors.$primary4;\n            color: colors.$primary4;\n        }\n\n        &.active{\n            border: none;\n            background-color: colors.$primary4;\n            color: #FFF;\n            cursor: initial;\n\n            svg path{\n                fill: #FFF;\n            }\n        }\n    }\n}\n\n.checkbox{\n    label{\n        font-weight: 300;\n    }\n    span {\n        display: inline;\n    }\n    a{\n        text-decoration: underline;\n    }\n}\n\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n    .choices{\n        flex-direction: column;\n        li{\n            width: 100%;\n        }\n    }\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"choices": `SignatureChoice_choices__Otmip`,
	"active": `SignatureChoice_active__78fN2`,
	"checkbox": `SignatureChoice_checkbox__wq6EA`
};
export default ___CSS_LOADER_EXPORT___;
